// google-maps-demo.component.ts
import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, ViewChild, ViewEncapsulation} from '@angular/core';
import { catchError, map, Subject, switchMap, take, takeUntil, throwError } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DecimalPipe, DOCUMENT, NgClass, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { GMapService } from 'app/services/gmap.service';
import { Istanza, IstanzeService } from 'app/services/istanze.service';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { UserService } from 'app/core/user/user.service';

export interface Position {
    id?: number;
    lat: number;
    lng: number;
    codice_interno?:string;
}

interface GMapProps extends FormlyFieldProps {

    id?: number;
    lat: number;
    lng: number;
    codice_interno?:string;
    maxsize: number;
    count: number;

}


@Component({
  selector: 'g-map',
  templateUrl: 'g-map.component.html',
  styleUrl: 'g-map.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, NgFor, NgClass, ReactiveFormsModule, FormsModule, MatIconModule, DecimalPipe]
})
export class GoogleMapTypeComponent extends FieldType<FieldTypeConfig<GMapProps>> implements AfterViewInit{

    @ViewChild('gmap') mapDiv: ElementRef;
    @ViewChild('gpano') panDiv: ElementRef;
    @ViewChild('layers') layerDiv: ElementRef;
    @ViewChild('layersButton') layersButton: ElementRef;
    @ViewChild('buttonEdit') buttonEdit : ElementRef;
    @ViewChild('infoEdit') infoEdit : ElementRef;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _istanzeService = inject(IstanzeService);
    private _mapService = inject(GMapService);
    private _changeDetectorRef = inject(ChangeDetectorRef);


    posizione: Position;
    tipo: string;

    gMap:google.maps.Map;
    marker: google.maps.marker.AdvancedMarkerElement

    private deleteButton: HTMLElement;

    editMode: boolean = false;
    baseMap: string;
    BaseMaps: any;

    checkLayers:boolean[];

    layerStatus:any;

    wmsLayers: any;

    layers:any[]=[];

    selectedLine: any
    lines:any



    status = 'out';

    over() {
      //console.log('Mouseover called');
      this.status = 'over';
    }

    out() {
      //console.log('Mouseout called');
      this.status = 'out';
    }




    ngOnInit(): void {



        this.BaseMaps = this._mapService.BaseMaps;
        this.baseMap = this._mapService.baseMapId;

        this.wmsLayers = this._mapService.wmsLayers;
        this.layerStatus = this._mapService.layerStatus;

    }


    ngAfterViewInit(): void {
        let map_options={}
        this. _istanzeService.istanza$
        .subscribe({
            next: (istanza) => {

                this._mapService.initMap(this.mapDiv.nativeElement, map_options, null).then((map)=>{
                    this.gMap = map;

                    this.field.options.formState.gMap = this.gMap;
                    this.field.options.formState.map = map

                    if (istanza.lat && istanza.lng){

                        const position: google.maps.LatLngLiteral = { lat:istanza.lat,lng:istanza.lng };
                        this._mapService.mapMarker.position=position;
                        this._mapService.mapMarker.map=map;

                        map.setCenter(position);
                        map.setZoom(18);
                    }
                    else {

                        this._mapService.mapMarker.position=map.getCenter();
                        this._mapService.mapMarker.map=map;

                    }

                    this.marker = this._mapService.mapMarker;
                    this.marker.addListener('dragend', (event) => {
                        const position = this.marker.position
                        console.log(position)
                    });



                    map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.layersButton.nativeElement);
                    //map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(this.infoEdit.nativeElement);

                    this._changeDetectorRef.markForCheck()


                })
                .catch((err) => console.error('Errore durante l\'inizializzazione della mappa:', err));

            },
            error: (err) => {
              console.error('Errore durante il caricamento dell\'istanza o della geometria:', err);
            },
          });

/*         .subscribe((istanza:Istanza) =>{


            this._mapService.initMap(this.mapDiv.nativeElement, map_options, istanza.geom).then((map)=>{
                this.gMap = map;

                this.field.options.formState.gMap = this.gMap;
                this.field.options.formState.map = map

                if (istanza.lat && istanza.lng){

                    const position: google.maps.LatLngLiteral = { lat:istanza.lat,lng:istanza.lng };
                    this._mapService.mapMarker.position=position;
                    this._mapService.mapMarker.map=map;


                    map.setCenter(position);
                    map.setZoom(18);


                }


                this.marker = this._mapService.mapMarker;
                this.marker.addListener('dragend', (event) => {
                    const position = this.marker.position
                    console.log(position)
                });

                map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.layersButton.nativeElement);
                //map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(this.infoEdit.nativeElement);


            }).catch((err)=>console.log(err))



        }) */


    }



    ngAfterViewInitxxxxxxxxxxxx(): void {
        let map_options={}
        this. _istanzeService.istanza$
        .pipe(
            take(1),
            switchMap(istanza=>this._mapService.getGeometry(istanza.id).pipe(
                map((geom)=>({ istanza, geom }))
            )),
            catchError((error) => {
                console.error("Errore", error);
                return throwError(error); // Gestione dell'errore
            })
        )
        .subscribe({
            next: ({ istanza, geom }) => {

                debugger
                this._mapService.initMap(this.mapDiv.nativeElement, map_options, geom).then((map)=>{
                    this.gMap = map;

                    this.field.options.formState.gMap = this.gMap;
                    this.field.options.formState.map = map

                    console.log(istanza)

                    if (istanza.lat && istanza.lng){

                        const position: google.maps.LatLngLiteral = { lat:istanza.lat,lng:istanza.lng };
                        this._mapService.mapMarker.position=position;
                        this._mapService.mapMarker.map=map;

                        map.setCenter(position);
                        map.setZoom(18);
                    }
                    else {

                        this._mapService.mapMarker.position=map.getCenter();
                        this._mapService.mapMarker.map=map;

                    }

                    this.marker = this._mapService.mapMarker;
                    this.marker.addListener('dragend', (event) => {
                        const position = this.marker.position
                        console.log(position)
                    });



                    map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.layersButton.nativeElement);
                    //map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(this.infoEdit.nativeElement);


                })
                .catch((err) => console.error('Errore durante l\'inizializzazione della mappa:', err));

            },
            error: (err) => {
              console.error('Errore durante il caricamento dell\'istanza o della geometria:', err);
            },
          });

/*         .subscribe((istanza:Istanza) =>{


            this._mapService.initMap(this.mapDiv.nativeElement, map_options, istanza.geom).then((map)=>{
                this.gMap = map;

                this.field.options.formState.gMap = this.gMap;
                this.field.options.formState.map = map

                if (istanza.lat && istanza.lng){

                    const position: google.maps.LatLngLiteral = { lat:istanza.lat,lng:istanza.lng };
                    this._mapService.mapMarker.position=position;
                    this._mapService.mapMarker.map=map;


                    map.setCenter(position);
                    map.setZoom(18);


                }


                this.marker = this._mapService.mapMarker;
                this.marker.addListener('dragend', (event) => {
                    const position = this.marker.position
                    console.log(position)
                });

                map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.layersButton.nativeElement);
                //map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(this.infoEdit.nativeElement);


            }).catch((err)=>console.log(err))



        }) */


    }


    center:any;
    display:any;

    moveMap(event: google.maps.MapMouseEvent) {
      if (event.latLng){
        this.center = event.latLng.toJSON();
        console.log(this.center)
      }
    }

    move(event: google.maps.MapMouseEvent) {
      if (event.latLng){
        this.display = event.latLng && event.latLng.toJSON();
        console.log(this.display)
      }
    }

    setEditMode(){
        this.editMode=true;
        this.marker.gmpDraggable=true
    }

    savePosition(){
        //this._mapService.updatePosition(this.marker.getPosition())
        const newPosition = {id: this.posizione.id, lat: this.marker.position.lat, lng: this.marker.position.lng}

        console.log(newPosition)



    }

    cancelPosition(){
        this.marker.position=this.gMap.getCenter();
        this.editMode = false;
    }

    setBaseMap(base: any){
        this._mapService.setBaseMap(base)
    }





    setOverlay(){
        this._mapService.layerStatus = this.layerStatus
        this._mapService.setOverlays()
    }




}
